module.exports = __webpack_public_path__ + "static/media/icon-rotate-right.31ea203b.png";